import Head from 'next/head'
import PageHeaderBanner from '@bww/beke-ui/PageHeader'
import FeaturedProject from '@bww/beke-ui/ProjectsGallery/FeaturedProject'
import ProjectsGallery from '@bww/beke-ui/ProjectsGallery'
import YourDreamCTA from '@bww/beke-ui/YourDreamCTA'

import { sanityClient } from '@bww/beke-lib/sanity-client'

export default function ProjectsPage({ featuredProject, projects }) {
  return (
    <>
      <Head>
        <title>Bathroom Design Project Gallery</title>
        <meta
          name="description"
          content="Photos and details of Bathroom Elegance's projects."
        />
      </Head>
      <PageHeaderBanner
        title="Completed Projects"
        categoryTitle="See What's Possible"
        noMargin
      />
      {featuredProject && (
        <div style={{ background: 'var(--color-alt-tint-light)' }}>
          <div className="container" style={{ paddingBlock: 80 }}>
            <FeaturedProject project={featuredProject} />
          </div>
        </div>
      )}
      <ProjectsGallery projects={projects} />
      <YourDreamCTA />
    </>
  )
}

export async function getStaticProps() {
  const { projects, featuredProject } = await sanityClient.fetch(
    `*[_id == "be-projects"][0]{
      featuredProject->{
        title,
        shortDescription,
        "slug": slug.current,
        "heroImg": images[0]{ ..., "lqip": asset->metadata.lqip },
      },
      projects[0...21]->{
        title,
        "slug": slug.current,
        "heroImg": images[0]{ ..., "lqip": asset->metadata.lqip },
      }
    }`,
  )

  return {
    props: {
      projects,
      featuredProject,
    },
  }
}
